<div class="rounded-2xl">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-3">
      <div
        class="bg-primary w-12 h-12 flex justify-center items-center text-2xl text-white rounded-full"
      >
        <i [class]="icon"></i>
      </div>
      <div>
        <p class="text-primary uppercase text-sm font-semibold tracking-wider">
          {{ title }}
        </p>
        <p class="text-neutral text-xs">Year: {{year}}</p>
      </div>
    </div>
  </div>
  <p class="text-3xl font-bold text-neutral mb-2">{{value}}</p>
</div>
